// Ships browser errors to the API's /client-logs sink so they land in
// CloudWatch (we use no third-party error tracker). Uses a bare fetch rather
// than the axios client so a logging call can never trip the client's 401
// refresh/redirect interceptor and loop.
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// Expected / noisy errors that would drown real signal. Auth redirects and
// not-found are normal control flow; network blips and 3p widget noise aren't
// actionable.
const IGNORED_PATTERNS: RegExp[] = [
  /Failed to fetch/i,
  /NetworkError/i,
  /Network Error/i,
  /\b40[134]\b/,
  /ResizeObserver loop/i,
  /Non-Error promise rejection/i,
  /Loading chunk \d+ failed/i,
];

export function shouldReport(message: string): boolean {
  if (!message) return false;
  return !IGNORED_PATTERNS.some((re) => re.test(message));
}

export function reportClientError(
  message: string,
  context?: Record<string, unknown>,
): void {
  if (!shouldReport(message)) return;
  try {
    void fetch(`${API_BASE_URL}/client-logs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        level: 'error',
        message: message.slice(0, 4000),
        context,
        url:
          typeof window !== 'undefined'
            ? window.location.pathname
            : undefined,
      }),
      keepalive: true,
    }).catch(() => {
      /* logging is best-effort — swallow */
    });
  } catch {
    /* never let logging itself throw into the app */
  }
}
